var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenSideBar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.067 15.808a.624.624 0 01-.442 1.067.626.626 0 01-.442-.183l-6.25-6.25a.624.624 0 010-.884l6.25-6.25a.626.626 0 01.884.884L10.26 10l5.808 5.808zM4.01 10l5.808-5.808a.625.625 0 10-.884-.884l-6.25 6.25a.625.625 0 000 .884l6.25 6.25a.624.624 0 10.884-.884L4.01 10z",
    fill: "currentColor"
  })));
}
export default SvgOpenSideBar;